<template>
    <div>
      <div class="order-wrap">
        <div class="order-message">
            <span>이마티콘</span>
            <strong>선물이 완료</strong>
            <span>되었습니다.</span>
        </div>
        <div class="order-emarticon">
					<span class="card-image-border-none" :style="{ backgroundImage: 'url(' + orderResult.imageUrl + ')' }"></span>
					<strong>{{ orderResult.prepaidCardNickName }}</strong>
          <div>
            <em>{{Number(orderResult.cashAmount).toLocaleString()}}</em>
          </div>
        </div>
        <div class="order-text-box position-gap">
            <strong>선물 받는 분</strong>
            <div>
                <em>받는 분</em>
                <span>{{orderResult.giftInfo.receiver}}</span>
            </div>
            <div>
                <em>연락처</em>
                <span>{{orderResult.giftInfo.receiverContact}}</span>
            </div>
            <div>
                <em>메세지</em>
                <span>{{orderResult.giftInfo.giftMessage}}</span>
            </div>
        </div>
<!--        <gray-line class="absolute"></gray-line>-->
        <div class="order-text-box">
          <strong>결제정보</strong>
          <div>
            <em>결제금액</em>
            <span>{{orderResult.paymentInfo.paymentAmount.toLocaleString()}} 원</span>
          </div>
          <div>
            <em>결제방법</em>
            <span>{{orderResult.paymentInfo.payToolName}}</span>
          </div>
<!--          <div v-if="orderResult.paymentInfo.installmentPlanMonths">-->
<!--            <em>할부</em>-->
<!--            <span>{{orderResult.paymentInfo.installmentPlanMonths}}</span>-->
<!--          </div>-->
        </div>
      </div>
      <div class="button-wrap bottom-sticky">
        <button class="button-bg-yellow-order" @click="goMain">이마티콘 홈으로</button>
      </div>
    </div>
</template>

<script>
import TopHeader from '@/components/layout/Header.vue';
import GrayLine from '@/components/common/GrayLine.vue';
import BottomButton from '@/components/common/BottomButton.vue';

export default {
    name: 'GiftComplete',
    components: { TopHeader, GrayLine, BottomButton },
    data() {
        return {

        }
    },
    props: {
			orderResult: Object,
    },
    methods:{
      /**
       * 이마티콘 메인 화면으로 이동하는 메소드
       */
      goMain(){
        if(this.$store.state.mberInfo.mberNo.substring(0,1) != 'C') { //시상용 분기 처리
          this.$router.push({ path: "/award/emarticonAwardHome" })
        } else {
          this.$router.push({ path: "/home" });
        }

      },
    }
};
</script>

<style lang="scss" scoped>
    
    @import '@/assets/styles/global.scss';
    .absolute { position: absolute; left: 0; right: 0;}
    .position-gap { margin-top: rem(285); }
    .order-wrap { padding: 0 rem(20);}
    .order-message {
        padding-top: rem(24);
        padding-bottom: rem(32);
        text-align: center;
        span {
            @include font-size(rem(20), rem(30), 400);
            color: $color-black-400;
            letter-spacing: -1px;
            &:first-of-type {
                display: block;
            }
        }
        strong {
            @include font-size(rem(20), rem(30), 700);
            color: $color-black-400;
            letter-spacing: -1px;
        }
    }
    .order-emarticon {
        position: absolute;
        left: 0;
        right: 0;
        @include flex-center;
        flex-direction: column;
        height: rem(285);
        background-color: $color-gray-200;
        span {
            &:first-child {
                display: inline-block;
                width: rem(216);
                height: rem(136);
                border-radius: rem(15);
            }
        }
        div {
            em {
                display: block;
                padding-top: rem(20);
                @include font-size(rem(26), rem(36), 700);
                @include font-roboto;
                letter-spacing: -0.78px;
                color: $color-black;
                &::after {
                    content: '원';
                    display: inline-block;
                    vertical-align: top;
                    @include font-noto-sans;
                    @include font-size(rem(22), rem(32), 700);
                    color: $color-black;
                }
            }
            strong {
                display: block;
                text-align: center;
                @include font-size(rem(14), rem(21), 700);
                letter-spacing: -0.7px;
                color: $color-black-400;
            }
        }
    }
    .order-text-box {
        strong {
            display: block;
            padding-top: rem(32);
            padding-bottom: rem(20);
            @include font-size(rem(16), rem(24), 700);
            color: $color-black;
            letter-spacing: -0.8px;
        }
        em, span {
            display: inline-block;
            @include font-size(rem(14), rem(21), 400);
            color: $color-black;
            letter-spacing: -0.7px;
            padding-right: rem(34);
            padding-bottom: rem(14);
        }
        div {
            &:nth-child(2) { em {padding-right: rem(32); padding-bottom: rem(12);} }
            &:nth-child(3) {
                span {
                    @include font-roboto;
                    font-size: rem(15);
                    letter-spacing: 0;
                }
            }
            &:last-child { padding-bottom: rem(18);}
        }
        &:nth-child(5) {
            div {
                &:nth-child(2) {
                    span {
                        @include font-roboto;
                        @include font-size(rem(15), rem(21), 400);
                        color: $color-black;
                    }
                }
                &:nth-child(3) {
                    em { padding-right: rem(32);}
                    span {
                        @include font-noto-sans;
                        @include font-size(rem(14), rem(21), 400);
                        letter-spacing: -0.7px;
                    }
                }
                &:nth-child(4) {
                    em {
                        padding-right: rem(56);
                    }
                }
                &:last-child { padding-bottom: rem(50);}
            }
        }
    }

    .bottom-sticky{
      position: sticky;
      bottom: 0;
    }
</style>